import { createSlice } from '@reduxjs/toolkit';
import {userResetPasswordApi} from '../LoginApi/loginApi';

const userResetPasswordSlice = createSlice({
  name: 'userResetPassword',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(userResetPasswordApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userResetPasswordApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(userResetPasswordApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default userResetPasswordSlice.reducer;
